class ApiScheduler {
  constructor({ maxConcurrent = parseInt(process.env.REACT_APP_MAX_CONCURRENT) || navigator.hardwareConcurrency || 6 } = {}) {
    this.queue = [];
    this.running = 0;
    this.maxConcurrent = maxConcurrent;
  }

  enqueue(apiFunc, priority = 0, { retries = 0, dedupeKey = null, signal } = {}) {
    return new Promise((resolve, reject) => {
      if (dedupeKey && this.queue.some(t => t.dedupeKey === dedupeKey)) {
        resolve(null)
        return;
      }

      if (signal && signal.aborted) return reject(new DOMException("Aborted", "AbortError"));

      const task = { apiFunc, resolve, reject, priority, retries, dedupeKey, signal };

      const index = this.queue.findIndex((t) => t.priority < priority);
      if (index === -1) {
        this.queue.push(task);
      } else {
        this.queue.splice(index, 0, task);
      }

      this._process();
    });
  }

  async _process() {
    if (this.running >= this.maxConcurrent) return;
    if (this.queue.length === 0) return;

    const { apiFunc, resolve, reject, retries, signal } = this.queue.shift();
    this.running++;

    try {
      if (signal && signal.aborted) throw new DOMException("Aborted", "AbortError");
      const result = await apiFunc(signal);
      resolve(result);
    } catch (err) {
      if (retries > 0) {
        this.enqueue(apiFunc, 0, { retries: retries - 1, signal })
            .then(resolve)
            .catch(reject);
      } else {
        reject(err);
      }
    } finally {
      this.running--;
      this._process();
    }
  }

  getStatus() {
    return {
      running: this.running,
      queued: this.queue.length,
      maxConcurrent: this.maxConcurrent,
    };
  }

  clearQueue() {
    this.queue = [];
  }
}

export const apiScheduler = new ApiScheduler();
